<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <a-spin :spinning="spinning">
        <img style="display: none;" id='reportLogo' src='@/assets/report_logo.png' alt='Report Logo'>
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="As of"><br>
                                        <a-date-picker v-model="inputDate" format="MM-DD-YYYY" placeholder="Start Date" style="width:100%" />
                                    </base-input>
                                </div>
                            </div>
                            <div class="row" v-if="site_type == 'ho'">
                                <div class="col-md-7">
                                    <base-input label="Location">
                                        <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" changeOnSelect/>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Format" >
                                        <select class="form-control" size="large" v-model="inputFormat">
                                            <option v-for="option in formatOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Display onhand">
                                        <select class="form-control" size="large" v-model="inputDisplay">
                                            <option v-for="option in displayOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select v-if="inputFormat == '1'" class="form-control" size="large" v-model="inputSortBy" @click.prevent="autoChange">
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                        <select v-else class="form-control" size="large" v-model="inputSortExtendedBy" @click.prevent="autoChange">
                                            <option v-for="option in sortExtendedOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                    </button>
                                </div>
                            </div>
        
                            <base-checkbox class="mb-3" v-model="isShowDecimal">
                                Show decimal
                            </base-checkbox>
                            <base-checkbox class="mb-3" v-model="isSeparateSite">
                                Separate per site
                            </base-checkbox>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                        {{toggleLabel}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
        </a-spin>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    // bryan
    import reportUtils, {dissectReportFilters} from '../../components/reportUtils';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import { getReportDescription } from '../../utilities';
    import {
        mapState
    } from 'vuex'

    var component_x;

    export default {
        props: {
          withCost: { type: Boolean }
        },
        data() {
            return {
                spinning: false,
                inputDate: moment().endOf('day'),
                inputGroupBy: 'supplier_id',
                groupOptions: [
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'division_id', value: 'Division'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'},
                    {key: 'design_id', value: 'Style'},
                    {key: 'color_id', value: 'Color'}
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputSortBy: 'stock_no',
                inputSortExtendedBy: 'stock_no',
                sortOptions: [
                    {key: 'stock_no', value: 'MFG Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'onhand_qty', value: 'On-Hand Quantity'}
                ],
                sortExtendedOptions: [
                    {key: 'stock_no', value: 'MFG Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'onhand_qty', value: 'On-Hand Quantity'},
                    {key: 'in_qty', value: 'Incoming Quantity'},
                    {key: 'out_qty', value: 'Outgoing Quantity'}
                ],
                inputDisplay: '1',
                displayOptions: [
                    {key: '1', value: 'All items regarless of onhand quantity'},
                    {key: '2', value: 'All items with onhand quantity only'},
                    {key: '3', value: 'All items with zero onhand quantity only'},
                    {key: '4', value: 'All items with negative onhand quantity only'},
                    {key: '5', value: 'All items with negative or zero onhand quantity'},
                    {key: '6', value: 'All items with positive or zero onhand quantity'},
                    {key: '7', value: 'All items except those with zero quantity'},
                ],
                inputFormat: '1',
                formatOptions: [
                    {key: '1', value: 'Simple'},
                    {key: '2', value: 'Extended'}
                ],
                isShowDecimal: false,
                isSeparateSite: false,
                birSalesReports: [],

                currDate: moment().format("L_LT").split(":").join(";"),
                showSortInfo: 'asc',
                JsonData: [],
                brandOptions: [],
                subBrandOptions: [],
                inputSubBrands: [],
                inputBrand: null,
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,
                reportData: [],
                totalPerGrpOnHand: 0,
                totalPerGrpPriceXQty: 0,
                totalPerGrpActualCost: 0,
                totalPerGrpInQty: 0,
                totalPerGrpOutQty: 0,
                totalPerGrpAvailable: 0,
                totalPerGrpOriginalCost: 0,
                totalPerGrpOrderingCost: 0,
                totalPerGrpLandedCost: 0,
                stockValuationParams: {},
                accessRights:[],
                accessCostPriceRights:[],
                reportDescription: '',
                inputLocation: [],
                locationOptions: []
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)
            component_x.getBrandOptions();
            this.accessRights = this.$attrs.access_rights || []
        
            var accessCostPriceRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=123", null)
            if (_.isEmpty(accessCostPriceRightsRequest.access_rights) == false){
                this.accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123]
            }else {
                this.accessCostPriceRights = []
            }
        },
        computed: {
            ...mapState(['currentProfile','endPoint']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(this.inputFormat == '1'){
                    this.inputSortExtendedBy = this.inputSortBy
                } else {
                    if(e.target.value == 'stock_no' || e.target.value == 'barcode' || e.target.value == 'name' || e.target.value == 'onhand_qty'){
                        this.inputSortBy = this.inputSortExtendedBy
                    } else {
                        this.inputSortBy = 'stock_no'
                    }
                }

            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            formatNumber(num) {
               return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            async onLocationChange(){
                var location = this.inputLocation[this.inputLocation.length - 1]
                if(!location){
                    this.handleClearInputLocation()
                }else {
                    this.siteOptions = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                    this.inputSite = this.siteOptions.map( s => s.id);
                }
                
            },
            async handleClearInputLocation() {
                    var userId = secureStorage.getItem("userId");
                    var sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                    this.siteOptions = sites;
                    this.sort(this.siteOptions);
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
                    let siteId = secureStorage.getItem("defaultSiteId");
                    this.inputSite = [siteId]
            },
            requestStockValuationBg: async function() {
                let sorting = this.inputSortBy
                if(this.inputFormat == '2'){
                    sorting = this.inputSortExtendedBy
                }

                let additional_params = ''
                if(this.inputBrand != null){
                    additional_params += `&brand_id=${this.inputBrand}`;
                }

                if (this.inputSubBrands.length > 0){
                    additional_params += `&sub_brand_ids=${this.inputSubBrands}`;
                }

                if (this.withCost) {
                    additional_params += `&with_cost=${this.withCost ? true : false}`;
                }

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "as_of": this.inputDate.format('YYYY-MM-DD HH:mm:ss'),
                    "group": this.inputGroupBy,
                    "order": sorting,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "display": this.inputDisplay,
                    "advanced_filter": this.params,
                    "isFormat": this.inputFormat
                }
                // bryan
                this.stockValuationParams = parameters

                if (this.withCost) {
                    parameters['with_cost'] = this.withCost;
                }

                let getRequest = await HTTPRequest.getRequestReport(this.endPoint + 'stock_valuations_background?', parameters);
                
                return getRequest;
            },
            requestStockValuation: async function() {
                let sorting = this.inputSortBy
                if(this.inputFormat == '2'){
                    sorting = this.inputSortExtendedBy
                }

                let additional_params = ''
                if(this.inputBrand != null){
                    additional_params += `&brand_id=${this.inputBrand}`;
                }

                if (this.inputSubBrands.length > 0){
                    additional_params += `&sub_brand_ids=${this.inputSubBrands}`;
                }

                if (this.withCost) {
                    additional_params += `&with_cost=${this.withCost ? true : false}`;
                }

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "as_of": this.inputDate.format('YYYY-MM-DD HH:mm:ss'),
                    "group": this.inputGroupBy,
                    "order": sorting,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "display": this.inputDisplay,
                    "advanced_filter": this.params,
                    "isFormat": this.inputFormat
                }
                // bryan
                this.stockValuationParams = parameters

                if (this.withCost) {
                    parameters['with_cost'] = this.withCost;
                }

                let getRequest = await HTTPRequest.getRequest(this.endPoint + 'stock_valuations?', parameters);
                
                return getRequest;
            },
            setPerGroupTotal(isPDF=false) {
              let perGroupArr = [];

              if(this.isShowDecimal == false){
                this.totalPerGrpOnHand = this.formatNumber(this.totalPerGrpOnHand);
                this.totalPerGrpInQty = this.formatNumber(this.totalPerGrpInQty);
                this.totalPerGrpOutQty = this.formatNumber(this.totalPerGrpOutQty);
                this.totalPerGrpAvailable = this.formatNumber(this.totalPerGrpAvailable);
              } else {
                this.totalPerGrpOnHand = this.convertToCurrency(this.totalPerGrpOnHand);
                this.totalPerGrpInQty = this.convertToCurrency(this.totalPerGrpInQty);
                this.totalPerGrpOutQty = this.convertToCurrency(this.totalPerGrpOutQty);
                this.totalPerGrpAvailable = this.convertToCurrency(this.totalPerGrpAvailable);
              }

              // Set Total Per Group
              perGroupArr.push('', '', 'Group Sub Total :',
                               this.totalPerGrpOnHand, '', this.addMaskValidation(this.convertToCurrency(this.totalPerGrpActualCost), 'Z'), this.addMaskValidation(this.convertToCurrency(this.totalPerGrpPriceXQty), 'Y'))

              // Set Total Per Group (With Cost)
              if (this.withCost) {
                perGroupArr.push(
                  this.addMaskValidation(this.convertToCurrency(this.totalPerGrpOriginalCost), 'Z'),
                  this.addMaskValidation(this.convertToCurrency(this.totalPerGrpOrderingCost), 'Z'),
                  this.addMaskValidation(this.convertToCurrency(this.totalPerGrpLandedCost), 'Z')
                )
              }

              // Set Total Per Group (Extended)
              if (this.inputFormat == '2') {
                perGroupArr.push(
                  this.totalPerGrpInQty,
                  this.totalPerGrpOutQty,
                  this.totalPerGrpAvailable
                )
              }

              if (isPDF) { this.reportData.push(Object.assign({}, ["rowLine"])); }
              this.reportData.push(perGroupArr)

              // Set all total per group to zero
              this.totalPerGrpOnHand = 0;
              this.totalPerGrpActualCost = 0;
              this.totalPerGrpPriceXQty = 0;
              this.totalPerGrpInQty = 0;
              this.totalPerGrpOutQty = 0;
              this.totalPerGrpAvailable = 0;
              this.totalPerGrpOriginalCost = 0;
              this.totalPerGrpOrderingCost = 0;
              this.totalPerGrpLandedCost = 0;
            },
            // bryan
            generateReport: async function () {
                this.spinning= true;
                this.reportData = [];

                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let as_of = this.inputDate.format('MMMM DD, YYYY');

                let get_request = await this.requestStockValuationBg();

                
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }else{
                    console.log("No error")
                    this.$notification['success']({
                        message: 'Report Generating',
                        description: "Report running in background. Check jobs page to monitor report generation.",
                        style:{
                            color: 'rgba(0, 0, 0, 0.65)',
                            border: '1px solid #b7eb8f',
                            backgroundColor: '#f6ffed'
                        }
                    });
                    // reportUtils.openNotificationWithIcon(component_x, 'success', "Report running in background. Check jobs page to monitor report generation.");
                }

                this.spinning= false;
                // let siteSpecific = get_request;
                // if(siteSpecific.length > 0){
                //     let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                //     let reportLogo = document.getElementById('reportLogo');
                //     doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                //     let headers = [];

                //     let header_detail = [];

                //     header_detail.push(
                //         {content: 'Stock #', styles: {halign: 'center'}},
                //         {content: 'Barcode', styles: {halign: 'center'}},
                //         {content: 'Description', styles: {halign: 'center'}},
                //         {content: 'On-hand\n(Pcs)', styles: {halign: 'center'}},
                //         {content: 'Price\n(SRP)', styles: {halign: 'center'}},
                //         {content: 'Actual Cost', styles: {halign: 'center'}},
                //         {content: 'Total Price\n(SRP)', styles: {halign: 'center'}}
                //     )

                //     if(this.withCost){
                //       header_detail.push(
                //         {content: 'Total Original\nCost', styles: {halign: 'center'}},
                //         {content: 'Total Ordering\nCost', styles: {halign: 'center'}},
                //         {content: 'Total Landed\nCost', styles: {halign: 'center'}}
                //       )
                //     }

                //     if(this.inputFormat == '2'){
                //         header_detail.push(
                //             {content: 'Incoming\n(Pcs)', styles: {halign: 'center'}},
                //             {content: 'Outgoing\n(Pcs)', styles: {halign: 'center'}},
                //             {content: 'Available\n(Pcs)', styles: {halign: 'center'}}
                //         )
                //     }

                //     headers = [header_detail]
                //     let grand_onhand_qty = 0
                //     let grand_price_x_qty = 0
                //     let grand_in_qty = 0
                //     let grand_out_qty = 0
                //     let grand_available = 0
                //     let grand_original_cost = 0;
                //     let grand_ordering_cost = 0;
                //     let grand_landed_cost = 0;
                //     let product_array = []

                //     for(let x=0; x < siteSpecific.length; x++){
                //         this.birSalesReports = siteSpecific[x].report_details

                //         if(x > 0 && this.birSalesReports.length > 0){
                //             doc.addPage();
                //         }

                //         if(this.birSalesReports.length > 0){
                //             let grouper = 'start'

                //             let total_onhand_qty = 0
                //             let total_price_x_qty = 0
                //             let total_in_qty = 0
                //             let total_out_qty = 0
                //             let total_available = 0
                //             let total_original_cost = 0;
                //             let total_ordering_cost = 0;
                //             let total_landed_cost = 0;

                //             for(let i=0; i < this.birSalesReports.length; i++){
                //                 let reportLine = this.birSalesReports[i]
                //                 let grouper_name = reportLine.grouper_name

                //                 let onhand_qty = Number(reportLine.onhand_qty)
                //                 let out_qty = Number(reportLine.out_qty)
                //                 let in_qty = Number(reportLine.in_qty)
                //                 if(this.isShowDecimal == false){
                //                     onhand_qty = parseInt(reportLine.onhand_qty)
                //                     out_qty = parseInt(reportLine.out_qty)
                //                     in_qty = parseInt(reportLine.in_qty)
                //                 }

                //                 if (product_array.includes(reportLine.product_id) == false){
                //                     product_array.push(reportLine.product_id)
                //                 }

                //                 if(grouper == 'start'){
                //                     let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                //                     this.reportData.push(Object.assign({}, detail_header))
                //                 } else {
                //                     if(grouper != reportLine.grouper_id){
                //                         this.setPerGroupTotal(true);

                //                         let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                //                         this.reportData.push(Object.assign({}, detail_header))
                //                     }
                //                 }
                //                 grouper = reportLine.grouper_id

                //                 let price_x_qty = onhand_qty * Number(reportLine.price)
                //                 let available = onhand_qty - out_qty

                //                 let onhand_qty_display = this.convertToCurrency(onhand_qty)
                //                 if(this.isShowDecimal == false){
                //                     onhand_qty_display = this.formatNumber(onhand_qty)
                //                 }

                //                 let detail = []
                //                 detail = [
                //                     reportLine.stock_no,
                //                     reportLine.barcode,
                //                     {content: reportLine.name, styles: {halign: 'left'}},
                //                     onhand_qty_display,
                //                     this.addMaskValidation(this.convertToCurrency(Number(reportLine.price)), 'Y'),
                //                     this.addMaskValidation(this.convertToCurrency(Number(reportLine.actual_cost)), 'Z'),
                //                     this.addMaskValidation(this.convertToCurrency(price_x_qty), 'Y')
                //                 ]

                //                 if(this.withCost){
                //                   const originalCost = onhand_qty * Number(reportLine.original_cost);
                //                   const orderingCost = onhand_qty * Number(reportLine.ordering_cost);
                //                   const landedCost = onhand_qty * Number(reportLine.landed_cost);

                //                   detail.push(
                //                     this.addMaskValidation(this.convertToCurrency(originalCost), 'Z'),
                //                     this.addMaskValidation(this.convertToCurrency(orderingCost), 'Z'),
                //                     this.addMaskValidation(this.convertToCurrency(landedCost), 'Z'),
                //                   )

                //                   // Add grand total of all costs
                //                   if (this.isSeparateSite) {
                //                     total_original_cost += originalCost;
                //                     total_ordering_cost += orderingCost;
                //                     total_landed_cost += landedCost;
                //                   }

                //                   this.totalPerGrpOriginalCost += originalCost;
                //                   this.totalPerGrpOrderingCost += orderingCost;
                //                   this.totalPerGrpLandedCost += landedCost;

                //                   // Set costs total if export is separated with sites
                //                   grand_original_cost += originalCost;
                //                   grand_ordering_cost += orderingCost;
                //                   grand_landed_cost += landedCost;
                //                 }

                //                 total_onhand_qty += onhand_qty
                //                 total_price_x_qty += price_x_qty

                //                 this.totalPerGrpOnHand += onhand_qty;
                //                 this.totalPerGrpPriceXQty += price_x_qty;

                //                 grand_onhand_qty += onhand_qty
                //                 grand_price_x_qty += price_x_qty

                //                 let in_qty_display = 0
                //                 let out_qty_display = 0
                //                 let available_display = 0

                //                 if(this.inputFormat == '2'){
                //                     in_qty_display = this.convertToCurrency(in_qty)
                //                     out_qty_display = this.convertToCurrency(out_qty)
                //                     available_display = this.convertToCurrency(available)

                //                     if(this.isShowDecimal == false){
                //                         in_qty_display = this.formatNumber(in_qty)
                //                         out_qty_display = this.formatNumber(out_qty)
                //                         available_display = this.formatNumber(available)
                //                     }

                //                     detail.push(
                //                         in_qty_display,
                //                         out_qty_display,
                //                         available_display
                //                     )

                //                     total_in_qty += in_qty
                //                     total_out_qty += out_qty
                //                     total_available += available

                //                     this.totalPerGrpInQty += in_qty;
                //                     this.totalPerGrpOutQty += out_qty;
                //                     this.totalPerGrpAvailable += available;

                //                     grand_in_qty += in_qty
                //                     grand_out_qty += out_qty
                //                     grand_available += available
                //                 }

                //                 this.reportData.push(Object.assign({}, detail))

                //                 let sub_detail = []
                //                 if(i == this.birSalesReports.length-1){
                //                     let total_onhand_display = this.convertToCurrency(total_onhand_qty)
                //                     let total_in_display = this.convertToCurrency(total_in_qty)
                //                     let total_out_display = this.convertToCurrency(total_out_qty)
                //                     let total_available_display = this.convertToCurrency(total_available)

                //                     let grand_onhand_display = this.convertToCurrency(grand_onhand_qty)
                //                     let grand_in_display = this.convertToCurrency(grand_in_qty)
                //                     let grand_out_display = this.convertToCurrency(grand_out_qty)
                //                     let grand_available_display = this.convertToCurrency(grand_available)

                //                     if(this.isShowDecimal == false){
                //                         total_onhand_display = this.formatNumber(total_onhand_qty)
                //                         total_in_display = this.formatNumber(total_in_qty)
                //                         total_out_display = this.formatNumber(total_out_qty)
                //                         total_available_display = this.formatNumber(total_available)

                //                         grand_onhand_display = this.formatNumber(grand_onhand_qty)
                //                         grand_in_display = this.formatNumber(grand_in_qty)
                //                         grand_out_display = this.formatNumber(grand_out_qty)
                //                         grand_available_display = this.formatNumber(grand_available)
                //                     }

                //                     this.setPerGroupTotal(true);

                //                     if(this.isSeparateSite == true){
                //                         sub_detail = ['', '', 'Site Sub Total :',
                //                             total_onhand_display, '',
                //                             this.addMaskValidation(this.convertToCurrency(total_price_x_qty), 'Y')
                //                         ]

                //                         if (this.withCost) {
                //                           // Grand Total for Original, Ordering and Landed Costs
                //                           sub_detail.push(
                //                             this.addMaskValidation(this.convertToCurrency(total_original_cost), 'Z'),
                //                             this.addMaskValidation(this.convertToCurrency(total_ordering_cost), 'Z'),
                //                             this.addMaskValidation(this.convertToCurrency(total_landed_cost), 'Z')
                //                           );
                //                         }

                //                         if(this.inputFormat == '2'){
                //                             sub_detail.push(
                //                                 total_in_display,
                //                                 total_out_display,
                //                                 total_available_display
                //                             )
                //                         }
                //                         this.reportData.push(Object.assign({}, ["rowLine"]))
                //                         this.reportData.push(Object.assign({}, sub_detail))
                //                     } else {
                //                         //Grand Total
                //                         this.reportData.push(Object.assign({}, ["rowLine"]))

                //                         let grand_detail = ['Assortment: ', product_array.length, 'Grand Total :',
                //                             grand_onhand_display, '', '',
                //                             this.addMaskValidation(this.convertToCurrency(grand_price_x_qty), 'Y')
                //                         ]

                //                         if (this.withCost) {
                //                           // Grand Total for Original, Ordering and Landed Costs
                //                           grand_detail.push(
                //                             this.addMaskValidation(this.convertToCurrency(grand_original_cost), 'Z'),
                //                             this.addMaskValidation(this.convertToCurrency(grand_ordering_cost), 'Z'),
                //                             this.addMaskValidation(this.convertToCurrency(grand_landed_cost), 'Z')
                //                           );
                //                         }

                //                         if(this.inputFormat == '2'){
                //                             grand_detail.push(
                //                                 grand_in_display,
                //                                 grand_out_display,
                //                                 grand_available_display
                //                             )
                //                         }
                //                         this.reportData.push(Object.assign({}, grand_detail));
                //                     }
                //                 }
                //             }
                //         }

                //         if(x == siteSpecific.length - 1){
                //             if(this.isSeparateSite == true){
                //                 let grand_onhand_display = this.convertToCurrency(grand_onhand_qty)
                //                 let grand_in_display = this.convertToCurrency(grand_in_qty)
                //                 let grand_out_display = this.convertToCurrency(grand_out_qty)
                //                 let grand_available_display = this.convertToCurrency(grand_available)

                //                 if(this.isShowDecimal == false){
                //                     grand_onhand_display = this.formatNumber(grand_onhand_qty)
                //                     grand_in_display = this.formatNumber(grand_in_qty)
                //                     grand_out_display = this.formatNumber(grand_out_qty)
                //                     grand_available_display = this.formatNumber(grand_available)
                //                 }

                //                 //Grand Total
                //                 this.reportData.push(Object.assign({}, ["rowLine"]))

                //                 let grand_detail = ['Assortment: ', product_array.length, 'Grand Total :',
                //                     grand_onhand_display, '', '',
                //                     this.addMaskValidation(this.convertToCurrency(grand_price_x_qty), 'Y')
                //                 ]

                //                 if (this.withCost) {
                //                   // Grand Total for Original, Ordering and Landed Costs
                //                   grand_detail.push(
                //                     this.addMaskValidation(this.convertToCurrency(grand_original_cost), 'Z'),
                //                     this.addMaskValidation(this.convertToCurrency(grand_ordering_cost), 'Z'),
                //                     this.addMaskValidation(this.convertToCurrency(grand_landed_cost), 'Z')
                //                   );
                //                 }

                //                 if(this.inputFormat == '2'){
                //                     grand_detail.push(
                //                         grand_in_display,
                //                         grand_out_display,
                //                         grand_available_display
                //                     )
                //                 }
                //                 this.reportData.push(Object.assign({}, grand_detail));
                //             }
                //         }

                //         let group_text = ""
                //         if(this.inputGroupBy != ''){
                //             group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                //         }

                //         doc.setFontSize(14);
                //         doc.setFontType("bold");
                //         doc.text(15,20,"Stock Valuation Report" + group_text)
                //         doc.setFontType("normal");
                //         doc.setFontSize(10);
                //         // bryan
                //         doc.text(15,25,"As of " + as_of)
                //         if(this.isSeparateSite == true){
                //             // doc.text(340,20,siteSpecific[x].report_details[0].site_name,"right");
                //             doc.text(15, 30, `Site/s: ${siteSpecific[x].report_details[0].site_name}`)
                //         } else {
                //             let site_text = ''
                //             if(this.inputSite.length == 0){
                //                 site_text = 'All Sites'
                //             } else {
                //                 let sites = this.inputSite
                //                 for (var s = 0; s < sites.length; s++) {
                //                     if(s == 0){
                //                         site_text += this.siteOptions.find(x => x.id === sites[s]).name
                //                     } else {
                //                         site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                //                     }
                //                 }
                //             }
                //             doc.text(15, 30, `Site/s: ${site_text}`)
                //             // doc.text(340,20,site_text,"right");
                //         }
                //         let parameters = this.stockValuationParams
                //         let filterText = dissectReportFilters(parameters, this.displayOptions, this.formatOptions)
                //         const {basic, advance} = filterText
                //         doc.text(15, 35, `Filter/s: ${basic}`)
                //         if (Object.keys(parameters.advanced_filter).length !== 0) {
                //             doc.text(15, 40, `Product Filter/s: ${advance}`)
                //         }
                //         // until here

                //         let desc_width = 60

                //         if(this.inputFormat == '1' && !this.withCost){
                //           desc_width = 155
                //         } else if (this.inputFormat == '2' && this.withCost) {
                //           desc_width = 50
                //         }

                //         let colStyles = {}
                //         colStyles = {
                //           0: {cellWidth: 30},
                //           1: {cellWidth: 30},
                //           2: {cellWidth: desc_width},
                //           3: {cellWidth: 30},
                //           4: {cellWidth: 30},
                //           5: {cellWidth: 30}
                //         }

                //         if (this.inputFormat == '2' && this.withCost) {
                //           colStyles = {
                //             ...colStyles,
                //             3: {cellWidth: 20},
                //             6: {cellWidth: 25},
                //             7: {cellWidth: 25},
                //             8: {cellWidth: 25},
                //             9: {cellWidth: 20},
                //             10: {cellWidth: 20},
                //             11: {cellWidth: 20}
                //           }
                //         } else if (this.inputFormat == '2' || this.withCost) {
                //           colStyles = {
                //             ...colStyles,
                //             6: {cellWidth: 30},
                //             7: {cellWidth: 30},
                //             8: {cellWidth: 30},
                //           }
                //         }

                //         doc.autoTable({
                //             // startY: 35,
                //             // bryan
                //             startY: Object.keys(this.params).length !== 0? 45 : 40,
                //             head: headers,
                //             body: this.reportData,
                //             theme: 'plain',
                //             tableWidth: 'wrap',
                //             headStyles: {
                //                 lineWidth: 0.15,
                //                 cellPadding: 2
                //             },
                //             styles: {
                //                 cellPadding: 1.0, fontSize: 10,
                //                 halign: 'right'
                //             },
                //             margin: {bottom: 30},
                //             columnStyles: colStyles,
                //             didParseCell: function(data) {
                //                 if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                //                     data.cell.styles.fillColor = [0, 0, 0]
                //                     data.cell.styles.fontSize = 1
                //                     data.cell.styles.cellPadding = 0
                //                 } else if (data.row.section == 'body' && ['Grand Total :', 'Site Sub Total :', 'Group Sub Total :'].includes(data.row.raw[2])){
                //                     data.cell.styles.fontStyle = 'bold'
                //                 }
                //             }
                //         });
                //         if(this.inputFormat != '1'){
                //             var finalY = doc.lastAutoTable.finalY;
                //             var legends = ['Available = On-Hand - Outgoing']
                //             reportUtils.pdfTools.addLegend(doc, legends, finalY)
                //         }

                //         let printed_by = secureStorage.getItem("email")
                //         if(printed_by == null){
                //             printed_by = ''
                //         }

                //         let pageCount = doc.internal.getNumberOfPages();

                //         for(let i = 1; i <= pageCount; i++) {
                //             doc.setPage(i);
                //             reportUtils.pdfTools.addFooter(doc, printed_by, "Stock Valuation Report" + group_text, 340, 200, i, pageCount)
                //         }

                       

                //     }

                    
                //     window.open(URL.createObjectURL(doc.output("blob")))
                //     // doc.save(`Stock_Valuation_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                // } else {
                //     reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                // }
                
            },

            generateFile: async function() {
                this.spinning= true;
                if(this.isSeparateSite == false){
                    this.reportData = [];
                }

                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let get_request = await this.requestStockValuation();

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }
                let siteSpecific = get_request;

                // console.log(">>siteSpecific")
                // console.log(siteSpecific)

                if(get_request.length > 0){

                    console.log("GET REQUEST WITH VALUE..")

                    let headers = [];
                    let site_specific = [];
                    let header_detail = [];

                    if(secureStorage.getItem("accountName").toLowerCase() == "goldwing"){
                        header_detail.push('Stock #','Barcode','Description','On-hand\n(Pcs)','Price\n(SRP)','Landed Cost','Total Price\n(SRP)');
                    } else {
                        header_detail.push('Stock #','Barcode','Description','On-hand\n(Pcs)','Price\n(SRP)','Actual Cost','Total Price\n(SRP)');
                    }

                    if (this.withCost) {
                      header_detail.push('Total Original Cost', 'Total Ordering Cost', 'Total Landed Cost');
                    }

                    if(this.inputFormat == '2'){
                        console.log("Should be here...")
                        header_detail.push('Incoming\n(Pcs)','Outgoing\n(Pcs)','Available\n(Pcs)');
                    }

                    headers = header_detail
                    let grand_onhand_qty = 0
                    let grand_price_x_qty = 0
                    let grand_actual_cost = 0;

                    let grand_in_qty = 0
                    let grand_out_qty = 0
                    let grand_available = 0
                    let grand_original_cost = 0;
                    let grand_ordering_cost = 0;
                    let grand_landed_cost = 0;
                    
                    let product_array = []

                    for(let x=0; x < siteSpecific.length; x++){

                        if(this.isSeparateSite == true){
                            this.reportData = [];
                        }

                        this.birSalesReports = siteSpecific[x].report_details
                        
                        // console.log(">>> birSalesReports")
                        // console.log(this.birSalesReports)

                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let total_onhand_qty = 0;
                            let total_price_x_qty = 0;
                            let total_in_qty = 0;
                            let total_out_qty = 0;
                            let total_available = 0;
                            let total_original_cost = 0;
                            let total_ordering_cost = 0;
                            let total_landed_cost = 0;
                            let total_actual_cost = 0;

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name;

                                let onhand_qty = Number(reportLine.onhand_qty)
                                let out_qty = Number(reportLine.out_qty)
                                let in_qty = Number(reportLine.in_qty)
                                
                                if(this.isShowDecimal == false){
                                    onhand_qty = parseInt(reportLine.onhand_qty)
                                    out_qty = parseInt(reportLine.out_qty)
                                    in_qty = parseInt(reportLine.in_qty)
                                }

                                if (product_array.includes(reportLine.product_id) == false){
                                    product_array.push(reportLine.product_id)
                                }

                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    this.reportData.push(detail_header);
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                      this.setPerGroupTotal();

                                      let detail_header = [grouper_name];
                                      this.reportData.push(detail_header)
                                    }
                                }
                                grouper = reportLine.grouper_id

                                // console.log("Onhand Qty", onhand_qty)
                                // console.log("Price", Number(reportLine.price))
                                let price_x_qty = onhand_qty * Number(reportLine.price)
                                let available = onhand_qty - out_qty
                                let actual_cost = Number(reportLine.actual_cost)

                                let onhand_qty_display = this.convertToCurrency(onhand_qty)
                                if(this.isShowDecimal == false){
                                    onhand_qty_display = this.formatNumber(onhand_qty)
                                }

                                let detail = []
                                detail = [
                                    reportLine.stock_no,
                                    reportLine.barcode,reportLine.name,
                                    onhand_qty_display,
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.price)), 'Y'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.actual_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(price_x_qty)), 'Y')
                                ]

                                if (this.withCost) {
                                  const originalCost = onhand_qty * Number(reportLine.original_cost);
                                  const orderingCost = onhand_qty * Number(reportLine.ordering_cost);
                                  const landedCost = onhand_qty * Number(reportLine.landed_cost);

                                  detail.push(
                                    this.addMaskValidation(this.convertToCurrency(originalCost), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(orderingCost), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(landedCost), 'Z')
                                  );

                                  this.totalPerGrpOriginalCost += originalCost;
                                  this.totalPerGrpOrderingCost += orderingCost;
                                  this.totalPerGrpLandedCost += landedCost;

                                  // Add grand total of all costs
                                  grand_original_cost += originalCost;
                                  grand_ordering_cost += orderingCost;
                                  grand_landed_cost += landedCost;

                                  // Set costs total if export is separated with sites
                                  if (this.isSeparateSite) {
                                    total_original_cost += originalCost;
                                    total_ordering_cost += orderingCost;
                                    total_landed_cost += landedCost;
                                  }

                                }

                                total_onhand_qty += onhand_qty
                                total_price_x_qty += price_x_qty
                                total_actual_cost += actual_cost


                                this.totalPerGrpOnHand += onhand_qty
                                this.totalPerGrpPriceXQty += price_x_qty
                                this.totalPerGrpActualCost += actual_cost

                                grand_onhand_qty += onhand_qty
                                grand_price_x_qty += price_x_qty
                                grand_actual_cost += actual_cost

                                let in_qty_display = 0
                                let out_qty_display = 0
                                let available_display = 0

                                if(this.inputFormat == '2'){
                                    in_qty_display = this.convertToCurrency(in_qty)
                                    out_qty_display = this.convertToCurrency(out_qty)
                                    available_display = this.convertToCurrency(available) 

                                    if(this.isShowDecimal == false){
                                        in_qty_display = this.formatNumber(in_qty)
                                        out_qty_display = this.formatNumber(out_qty)
                                        available_display = this.formatNumber(available)
                                    }

                                    detail.push(
                                        in_qty_display,
                                        out_qty_display,
                                        available_display
                                    )

                                    total_in_qty += in_qty
                                    total_out_qty += out_qty
                                    total_available += available

                                    this.totalPerGrpInQty += in_qty;
                                    this.totalPerGrpOutQty += out_qty;
                                    this.totalPerGrpAvailable += available;

                                    grand_in_qty += in_qty
                                    grand_out_qty += out_qty
                                    grand_available += available
                                }

                                this.reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    let total_onhand_display = this.convertToCurrency(total_onhand_qty)
                                    let total_in_display = this.convertToCurrency(total_in_qty)
                                    let total_out_display = this.convertToCurrency(total_out_qty)
                                    let total_available_display = this.convertToCurrency(total_available)

                                    let grand_onhand_display = this.convertToCurrency(grand_onhand_qty)
                                    let grand_in_display = this.convertToCurrency(grand_in_qty)
                                    let grand_out_display = this.convertToCurrency(grand_out_qty)
                                    let grand_available_display = this.convertToCurrency(grand_available)

                                    if(this.isShowDecimal == false){
                                        total_onhand_display = this.formatNumber(total_onhand_qty)
                                        total_in_display = this.formatNumber(total_in_qty)
                                        total_out_display = this.formatNumber(total_out_qty)
                                        total_available_display = this.formatNumber(total_available)

                                        grand_onhand_display = this.formatNumber(grand_onhand_qty)
                                        grand_in_display = this.formatNumber(grand_in_qty)
                                        grand_out_display = this.formatNumber(grand_out_qty)
                                        grand_available_display = this.formatNumber(grand_available)
                                    }

                                    this.setPerGroupTotal();

                                    if(this.isSeparateSite == true){
                                        sub_detail = ['', '', 'Site Sub Total :',
                                          total_onhand_display, '',
                                          this.addMaskValidation(this.convertToCurrency(total_price_x_qty), 'Y'),
                                          this.addMaskValidation(this.convertToCurrency(total_actual_cost), 'Y')
                                        ]

                                        if (this.withCost) {
                                          sub_detail.push(
                                            this.addMaskValidation(this.convertToCurrency(total_original_cost), 'Z'),
                                            this.addMaskValidation(this.convertToCurrency(total_ordering_cost), 'Z'),
                                            this.addMaskValidation(this.convertToCurrency(total_landed_cost), 'Z')
                                          )
                                        }

                                        if(this.inputFormat == '2'){
                                          sub_detail.push(
                                            total_in_display,
                                            total_out_display,
                                            total_available_display
                                          )
                                        }
                                        this.reportData.push(Object.assign({}, sub_detail))
                                    } else {
                                        //Grand Total

                                        let grand_detail = ['Assortment: ', product_array.length, 'Grand Total :',
                                            grand_onhand_display, this.addMaskValidation(this.convertToCurrency(total_actual_cost), 'Y'),
                                            this.addMaskValidation(this.convertToCurrency(total_price_x_qty), 'Y'),
                                        ]

                                        if (this.withCost) {
                                          grand_detail.push(
                                            this.addMaskValidation(this.convertToCurrency(grand_original_cost), 'Z'),
                                            this.addMaskValidation(this.convertToCurrency(grand_ordering_cost), 'Z'),
                                            this.addMaskValidation(this.convertToCurrency(grand_landed_cost), 'Z')
                                          )
                                        }

                                        if(this.inputFormat == '2'){
                                            grand_detail.push(
                                                grand_in_display,
                                                grand_out_display,
                                                grand_available_display
                                            )
                                        }
                                        this.reportData.push(Object.assign({}, grand_detail));
                                    }
                                }
                            }
                        }

                        if(x == siteSpecific.length - 1){
                            if(this.isSeparateSite == true){
                                let grand_onhand_display = this.convertToCurrency(grand_onhand_qty)
                                let grand_in_display = this.convertToCurrency(grand_in_qty)
                                let grand_out_display = this.convertToCurrency(grand_out_qty)
                                let grand_available_display = this.convertToCurrency(grand_available)

                                if(this.isShowDecimal == false){
                                    grand_onhand_display = this.formatNumber(grand_onhand_qty)
                                    grand_in_display = this.formatNumber(grand_in_qty)
                                    grand_out_display = this.formatNumber(grand_out_qty)
                                    grand_available_display = this.formatNumber(grand_available)
                                }

                                //Grand Total

                                let grand_detail = ['Assortment: ', product_array.length, 'Grand Total :',
                                    grand_onhand_display, this.addMaskValidation(this.convertToCurrency(grand_actual_cost), 'Y'),
                                    this.addMaskValidation(this.convertToCurrency(grand_price_x_qty), 'Y')
                                ]

                                if (this.withCost) {
                                  grand_detail.push(
                                    this.addMaskValidation(this.convertToCurrency(grand_original_cost), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(grand_ordering_cost), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(grand_landed_cost), 'Z')
                                  )
                                }

                                if(this.inputFormat == '2'){
                                    grand_detail.push(
                                        grand_in_display,
                                        grand_out_display,
                                        grand_available_display
                                    )
                                }
                                this.reportData.push(Object.assign({}, grand_detail));
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.sortOptions[0].value
                        }

                        if(this.isSeparateSite == true){
                            this.reportData.push([siteSpecific[x].report_details[0].site_name]);
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            this.reportData.unshift([site_text]);
                        }

                        if(this.inputFormat != '1'){
                            var legends = ['Available = On-Hand - Outgoing']
                            this.reportData = reportUtils.csvxlsxTools.addLegend(this.reportData, legends)
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        this.reportData.push(["Stock Valuation Report" + group_text, "Generate By: " + printed_by])

                        let keys = headers;
                        let values = this.reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        // console.log("newJsonData for site:", newJsonData.length, newJsonData);
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                    // console.log("JsonData")
                    // console.log(this.JsonData )
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'No Data.');
                }
                this.spinning= false;
            },

            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },

            async getBrandOptions() {
                var brands = await HTTPRequest.getRequest(
                    this.endPoint + "/brands/get_valid_brands?",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.brandOptions = brands;

            },

            async getSubBrandData() {
                if (this.inputBrand != null) {
                    var subbrand_data = await HTTPRequest.getRequest(
                    this.endPoint +
                        "sub_brands/get_valid_sub_brands?brand_id=" +
                        this.inputBrand,
                    null
                    );
                    // console.log("sub_brand[index]:",subbrand_data);
                    this.subBrandOptions = subbrand_data;
                    // console.log(this.inputSubBrands)
                }
            },

            async clearSubBrand() {
                this.inputSubBrands = [];
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            }
        }
    };
</script>

<style></style>
